import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import BOSS_mainlogo from '../../../../assets/icons/BOSS_mainlogo.svg';
import { useNavigate } from 'react-router-dom';
import { Message } from 'primereact/message';
import './EmailForgotPassword.scss';
import GetRequest from '../../../../service/GetRequest';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [showMessage, setShowMessage] = useState(false);

  const navigate = useNavigate();

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    setEmailError(validateEmail(e.target.value) ? '' : 'Invalid email address');
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (emailError) {
      setError('Please fix the errors before submitting');
      return;
    }

    try {
      await GetRequest(`auth/forgot/password?email=${email}`);
      setMessage('A reset password link has been sent to your email.');
      setMessageType('success');
      setShowMessage(true);
      setTimeout(() => {
        setShowMessage(false);
        navigate('/login');
      }, 2000);
    } catch (err) {
      setError(err.message || 'User not found');
    }
  };

  return (
    <Container className="ForgotPasswordContainer">
      <Row>
        <Col xs={12} className="ForgotPasswordHeader">
          <img src={BOSS_mainlogo} alt="BOSS Logo" />
          <h2>Forgot Password</h2>
        </Col>
      </Row>
      <Row className="justify-content-md-center">
        <Col xs={12} md={6}>
          <div className="forgot-password-form">
            <Form onSubmit={handleEmailSubmit}>
              <Form.Label style={{ fontSize: "16px", fontWeight: "bold" }}>Email Address</Form.Label>
              <Form.Group controlId="formBasicEmail" className="form-email">
                <Form.Control
                  type="email"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={handleEmailChange}
                  isInvalid={!!emailError}
                  style={{ marginTop: "10px" }}
                />
                <Form.Control.Feedback type="invalid">
                  <p style={{ color: "red" }}>{emailError}</p>
                </Form.Control.Feedback>
              </Form.Group>
              {error && <div className="error"> <Message severity="error" text={error} /></div>}
              <Button variant="primary" type="submit" className="send-otp-button">
                Reset Password
              </Button>
            </Form>
          </div>
        </Col>
      {showMessage && (
        <Message severity="success" text={message} />
      )}
      </Row>
    </Container>
  );
};

export default ForgotPassword;
